webpackJsonp([255975594985170],{

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dimensions = __webpack_require__(28);
	
	var _dimensions2 = _interopRequireDefault(_dimensions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tabs = __webpack_require__(31);
	
	var Tabs = _interopRequireWildcard(_tabs);
	
	var _gatsbyLink = __webpack_require__(6);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Filter = function (_React$Component) {
	    _inherits(Filter, _React$Component);
	
	    function Filter() {
	        var _temp, _this, _ret;
	
	        _classCallCheck(this, Filter);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleSelectOption = function (e) {
	            (0, _gatsbyLink.navigateTo)({
	                all: "/",
	                writing: "/tags/writing",
	                art: "/tags/art"
	            }[e.target.value]);
	        }, _this.renderWithDimensions = function (_ref) {
	            var width = _ref.width;
	
	            return width < 600 ? _this.renderDropdown() : _this.renderTabs();
	        }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Filter.prototype.renderTabs = function renderTabs() {
	        var _props$query = this.props.query,
	            query = _props$query === undefined ? { tag: "all" } : _props$query;
	
	        console.log(query);
	
	        return _react2.default.createElement(
	            Tabs.Parent,
	            null,
	            _react2.default.createElement(
	                Tabs.Child,
	                {
	                    linkTo: '/', selected: query.tag === "all" },
	                'all'
	            ),
	            _react2.default.createElement(
	                Tabs.Child,
	                {
	                    linkTo: '/tags/writing', selected: query.tag === "writing" },
	                'writing'
	            ),
	            _react2.default.createElement(
	                Tabs.Child,
	                {
	                    linkTo: '/tags/art', selected: query.tag === "art" },
	                'art'
	            )
	        );
	    };
	
	    Filter.prototype.renderDropdown = function renderDropdown() {
	        var _props$query2 = this.props.query,
	            query = _props$query2 === undefined ? { tag: "all" } : _props$query2;
	
	        return _react2.default.createElement(
	            'select',
	            { onChange: this.handleSelectOption, value: query.tag },
	            _react2.default.createElement(
	                'option',
	                { value: 'all' },
	                'all'
	            ),
	            _react2.default.createElement(
	                'option',
	                { value: 'writing' },
	                'writing'
	            ),
	            _react2.default.createElement(
	                'option',
	                { value: 'art' },
	                'art'
	            )
	        );
	    };
	
	    Filter.prototype.render = function render() {
	        return _react2.default.createElement(
	            _dimensions2.default,
	            null,
	            this.renderWithDimensions
	        );
	    };
	
	    return Filter;
	}(_react2.default.Component);
	
	exports.default = Filter;
	module.exports = exports['default'];

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _header = __webpack_require__(46);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexPageModule = __webpack_require__(60);
	
	var _indexPageModule2 = _interopRequireDefault(_indexPageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Posts = function Posts(_ref) {
	    var data = _ref.data;
	    var posts = data.allMarkdownRemark.edges;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'blog-posts' },
	        posts.filter(function (post) {
	            return post.node.frontmatter.title.length > 0;
	        }).map(function (_ref2) {
	            var post = _ref2.node;
	
	            return _react2.default.createElement(
	                _gatsbyLink2.default,
	                {
	                    key: post.id,
	                    className: _indexPageModule2.default.PostPreview,
	                    to: post.frontmatter.path + '/'
	                },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    post.frontmatter.title
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    post.excerpt
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: _indexPageModule2.default.ReadMore },
	                    'read more \xBB'
	                )
	            );
	        })
	    );
	};
	
	var IndexPage = function IndexPage(_ref3) {
	    var data = _ref3.data,
	        children = _ref3.children;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _header2.default,
	            null,
	            children
	        ),
	        _react2.default.createElement(
	            'h3',
	            null,
	            'recent posts'
	        ),
	        _react2.default.createElement(Posts, { data: data })
	    );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Child = exports.Parent = undefined;
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tabsModule = __webpack_require__(41);
	
	var _tabsModule2 = _interopRequireDefault(_tabsModule);
	
	var _classnames = __webpack_require__(32);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Parent = function (_React$Component) {
	    _inherits(Parent, _React$Component);
	
	    function Parent() {
	        _classCallCheck(this, Parent);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Parent.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            { className: _tabsModule2.default.Parent },
	            this.props.children
	        );
	    };
	
	    return Parent;
	}(_react2.default.Component);
	
	var Child = function (_React$Component2) {
	    _inherits(Child, _React$Component2);
	
	    function Child() {
	        _classCallCheck(this, Child);
	
	        return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
	    }
	
	    Child.prototype.render = function render() {
	        var _cx;
	
	        var _props = this.props,
	            linkTo = _props.linkTo,
	            children = _props.children,
	            selected = _props.selected;
	
	        return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	                className: (0, _classnames2.default)(_tabsModule2.default.Child, (_cx = {}, _cx[_tabsModule2.default.selected] = selected, _cx)),
	                to: linkTo
	            },
	            children
	        );
	    };
	
	    return Child;
	}(_react2.default.Component);
	
	exports.Parent = Parent;
	exports.Child = Child;

/***/ }),

/***/ 41:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Parent":"src-components----tabs-module---Parent----dlnS","Child":"src-components----tabs-module---Child---JNKSW","selected":"src-components----tabs-module---selected---3WulQ"};

/***/ }),

/***/ 188:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _indexPage = __webpack_require__(30);
	
	var _indexPage2 = _interopRequireDefault(_indexPage);
	
	var _filterPosts = __webpack_require__(29);
	
	var _filterPosts2 = _interopRequireDefault(_filterPosts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WritingIndex = function WritingIndex(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _indexPage2.default,
	    {
	      data: data
	    },
	    _react2.default.createElement(_filterPosts2.default, { query: { tag: "writing" } })
	  );
	};
	
	exports.default = WritingIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tags-writing-js-6574501dd513060e5561.js